export const durations = {
  veryFast: 0.2,
  fast: 0.3,
  medium: 0.6,
  slow: 0.8,
  verySlow: 1.2,
};

export const easings = {
  default: [0.53, 0.22, 0.31, 1],
  pageTransition: [0.25, 0.1, 0.25, 1],
};

export const transitions = {
  veryFastTween: {
    duration: durations.veryFast,
    ease: easings.default,
  },

  fastTween: {
    duration: durations.fast,
    ease: easings.default,
  },

  mediumTween: {
    duration: durations.medium,
    ease: easings.default,
  },

  slowerMediumTween: {
    duration: durations.medium - durations.veryFast,
    ease: easings.pageTransition,
  },

  slowTween: {
    duration: durations.slow,
    ease: easings.default,
  },

  verySlowTween: {
    duration: durations.verySlow,
    ease: easings.default,
  },
};
